var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "custom-radio" }, [
        _c("label", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.exportOptions.language,
                expression: "exportOptions.language",
              },
            ],
            attrs: { type: "radio", value: "1" },
            domProps: { checked: _vm._q(_vm.exportOptions.language, "1") },
            on: {
              change: function ($event) {
                return _vm.$set(_vm.exportOptions, "language", "1")
              },
            },
          }),
          _vm._v("\n      выгружать кириллицу\n    "),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "custom-radio" }, [
        _c("label", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.exportOptions.language,
                expression: "exportOptions.language",
              },
            ],
            attrs: { type: "radio", value: "2" },
            domProps: { checked: _vm._q(_vm.exportOptions.language, "2") },
            on: {
              change: function ($event) {
                return _vm.$set(_vm.exportOptions, "language", "2")
              },
            },
          }),
          _vm._v("\n      выгружать английский\n    "),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.exportOptions.morions,
                expression: "exportOptions.morions",
              },
            ],
            staticClass: "from-control",
            attrs: { type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.exportOptions.morions)
                ? _vm._i(_vm.exportOptions.morions, null) > -1
                : _vm.exportOptions.morions,
            },
            on: {
              change: function ($event) {
                var $$a = _vm.exportOptions.morions,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 &&
                      _vm.$set(_vm.exportOptions, "morions", $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      _vm.$set(
                        _vm.exportOptions,
                        "morions",
                        $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                      )
                  }
                } else {
                  _vm.$set(_vm.exportOptions, "morions", $$c)
                }
              },
            },
          }),
          _vm._v("\n      экспортировать морионы (ID) препаратов\n    "),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.exportOptions.finance,
                expression: "exportOptions.finance",
              },
            ],
            staticClass: "from-control",
            attrs: { type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.exportOptions.finance)
                ? _vm._i(_vm.exportOptions.finance, null) > -1
                : _vm.exportOptions.finance,
            },
            on: {
              change: function ($event) {
                var $$a = _vm.exportOptions.finance,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 &&
                      _vm.$set(_vm.exportOptions, "finance", $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      _vm.$set(
                        _vm.exportOptions,
                        "finance",
                        $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                      )
                  }
                } else {
                  _vm.$set(_vm.exportOptions, "finance", $$c)
                }
              },
            },
          }),
          _vm._v(
            "\n      экспортировать фин. часть (стоимость, сумма, себестоимость)\n    "
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.extraOptions?.groupPrices
        ? _c("div", { staticClass: "form-group" }, [
            _c("label", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.exportOptions.groupPrices,
                    expression: "exportOptions.groupPrices",
                  },
                ],
                attrs: { type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.exportOptions.groupPrices)
                    ? _vm._i(_vm.exportOptions.groupPrices, null) > -1
                    : _vm.exportOptions.groupPrices,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.exportOptions.groupPrices,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.exportOptions,
                            "groupPrices",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.exportOptions,
                            "groupPrices",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.exportOptions, "groupPrices", $$c)
                    }
                  },
                },
              }),
              _vm._v("\n      Группировать препараты\n    "),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.extraOptions?.validDates
        ? _c("div", { staticClass: "form-group" }, [
            _c("label", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.exportOptions.validDates,
                    expression: "exportOptions.validDates",
                  },
                ],
                attrs: { type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.exportOptions.validDates)
                    ? _vm._i(_vm.exportOptions.validDates, null) > -1
                    : _vm.exportOptions.validDates,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.exportOptions.validDates,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.exportOptions,
                            "validDates",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.exportOptions,
                            "validDates",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.exportOptions, "validDates", $$c)
                    }
                  },
                },
              }),
              _vm._v("\n      Выгружать сроки годности\n    "),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.extraOptions?.invoiceNum
        ? _c("div", { staticClass: "form-group" }, [
            _c("label", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.exportOptions.invoiceNum,
                    expression: "exportOptions.invoiceNum",
                  },
                ],
                attrs: { type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.exportOptions.invoiceNum)
                    ? _vm._i(_vm.exportOptions.invoiceNum, null) > -1
                    : _vm.exportOptions.invoiceNum,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.exportOptions.invoiceNum,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.exportOptions,
                            "invoiceNum",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.exportOptions,
                            "invoiceNum",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.exportOptions, "invoiceNum", $$c)
                    }
                  },
                },
              }),
              _vm._v("\n      Выгружать номера накладных\n    "),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.extraOptions?.priceQtyRate
        ? _c("div", { staticClass: "form-group" }, [
            _c("label", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.exportOptions.priceQtyRate,
                    expression: "exportOptions.priceQtyRate",
                  },
                ],
                attrs: { type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.exportOptions.priceQtyRate)
                    ? _vm._i(_vm.exportOptions.priceQtyRate, null) > -1
                    : _vm.exportOptions.priceQtyRate,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.exportOptions.priceQtyRate,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.exportOptions,
                            "priceQtyRate",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.exportOptions,
                            "priceQtyRate",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.exportOptions, "priceQtyRate", $$c)
                    }
                  },
                },
              }),
              _vm._v(
                "\n      Учитывать коэфф. закупки и фасовку в блистерах\n    "
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.extraOptions?.showDetailsExpireDates
        ? _c("div", { staticClass: "form-group" }, [
            _c("label", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.exportOptions.showDetailsExpireDates,
                    expression: "exportOptions.showDetailsExpireDates",
                  },
                ],
                attrs: { type: "checkbox" },
                domProps: {
                  checked: Array.isArray(
                    _vm.exportOptions.showDetailsExpireDates
                  )
                    ? _vm._i(_vm.exportOptions.showDetailsExpireDates, null) >
                      -1
                    : _vm.exportOptions.showDetailsExpireDates,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.exportOptions.showDetailsExpireDates,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.exportOptions,
                            "showDetailsExpireDates",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.exportOptions,
                            "showDetailsExpireDates",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.exportOptions, "showDetailsExpireDates", $$c)
                    }
                  },
                },
              }),
              _vm._v(
                "\n      Выгружать сроки годности препаратов в накладных\n    "
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.extraOptions?.incomeByFact
        ? [
            _c("div", { staticClass: "custom-radio" }, [
              _c("label", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.exportOptions.qtyByFact,
                      expression: "exportOptions.qtyByFact",
                    },
                  ],
                  attrs: { type: "radio", value: "0" },
                  domProps: {
                    checked: _vm._q(_vm.exportOptions.qtyByFact, "0"),
                  },
                  on: {
                    change: function ($event) {
                      return _vm.$set(_vm.exportOptions, "qtyByFact", "0")
                    },
                  },
                }),
                _vm._v(
                  "\n        выгружать закупочное количество препаратов\n      "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "custom-radio" }, [
              _c("label", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.exportOptions.qtyByFact,
                      expression: "exportOptions.qtyByFact",
                    },
                  ],
                  attrs: { type: "radio", value: "1" },
                  domProps: {
                    checked: _vm._q(_vm.exportOptions.qtyByFact, "1"),
                  },
                  on: {
                    change: function ($event) {
                      return _vm.$set(_vm.exportOptions, "qtyByFact", "1")
                    },
                  },
                }),
                _vm._v(
                  "\n        выгружать фактическое количество препаратов\n      "
                ),
              ]),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.extraOptions?.expDatesSelected
        ? [
            _c("label", [_vm._v("Был выбран фильтр по срокам годности")]),
            _vm._v(" "),
            _c("div", [
              _c("label", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.exportOptions.selectedRecordsOnly,
                      expression: "exportOptions.selectedRecordsOnly",
                    },
                  ],
                  attrs: { type: "radio" },
                  domProps: {
                    value: 0,
                    checked: _vm._q(_vm.exportOptions.selectedRecordsOnly, 0),
                  },
                  on: {
                    change: function ($event) {
                      return _vm.$set(
                        _vm.exportOptions,
                        "selectedRecordsOnly",
                        0
                      )
                    },
                  },
                }),
                _vm._v("\n        выгружать все позиции\n      "),
              ]),
            ]),
            _vm._v(" "),
            _c("div", [
              _c("label", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.exportOptions.selectedRecordsOnly,
                      expression: "exportOptions.selectedRecordsOnly",
                    },
                  ],
                  attrs: { type: "radio" },
                  domProps: {
                    value: 1,
                    checked: _vm._q(_vm.exportOptions.selectedRecordsOnly, 1),
                  },
                  on: {
                    change: function ($event) {
                      return _vm.$set(
                        _vm.exportOptions,
                        "selectedRecordsOnly",
                        1
                      )
                    },
                  },
                }),
                _vm._v(
                  "\n        выгружать только отфильтрованные позиции\n      "
                ),
              ]),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }